import { render, staticRenderFns } from "./PlatformSupplierOffersComponent.vue?vue&type=template&id=3eaf4924&"
import script from "./PlatformSupplierOffersComponent.vue?vue&type=script&lang=js&"
export * from "./PlatformSupplierOffersComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports